import React, { useContext, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { Avatar, ListItem, ListItemIcon, Typography } from "@mui/material";
import { IdentityContext } from "@react-beets/identity";
import { ROUTES } from "../../../constants";

function IdentityButton() {
  const history = useHistory();
  const { identity } = useContext(IdentityContext);

  if (!identity || !identity.profile) return null;

  const fullName = `${identity.profile?.given_name} ${identity.profile?.family_name}`;
  const onClick = () => {
    history.push(ROUTES.MANAGE_PROFILE);
  };

  return (
    <ListItem onClick={onClick} button={true}>
      <ListItemIcon>
        <Avatar sx={{ width: 24, height: 24 }}></Avatar>
      </ListItemIcon>
      <Typography variant="inherit" noWrap>
        {fullName}
      </Typography>
    </ListItem>
  );
}

export default IdentityButton;
